import request from '@/utils/request'

export function save(data) {
  return request({
    url: '/api/manage/memo',
    method: 'post',
    data
  })
}

export function getPage(params) {
  return request({
    url: '/api/manage/memo/page',
    method: 'get',
    params
  })
}

export function setStatus(data) {
  return request({
    url: '/api/manage/memo/status',
    method: 'post',
    data
  })
}

export function setTop(data) {
  return request({
    url: '/api/manage/memo/top',
    method: 'post',
    data
  })
}

export function getDetail(memoBookId) {
  return request({
    url: `/api/manage/memo/${memoBookId}`,
    method: 'get',
  })
}

export function del(memoBookId) {
  return request({
    url: `/api/manage/memo/${memoBookId}`,
    method: 'delete',
  })
}

export default {
  getPage,
  save,
  setStatus,
  setTop,
  getDetail,
  del
}
